module.exports = __webpack_public_path__ + "mo/img/ai01.8486f151.png";